// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7f-0";
export var startPickingButton = "_7f-1";